import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon, ButtonGroup } from '@material-ui/core';
import momentPropTypes from 'react-moment-proptypes';

import { Button } from '..';

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: '6px',
  },
  buttonGroup: {
    flexWrap: 'wrap',
  },
  button: {
    fontSize: '0.6rem',
    flex: '1',
  },
};

class DateRangeStepper extends Component {
  addToDate = (value, unit) => {
    const { startDate, endDate, onDatesChanged } = this.props;

    onDatesChanged({
      startDate: startDate.add(value, unit).unix(),
      endDate: endDate.add(value, unit).unix(),
    });
  }

  renderPrevious() {
    return (
      <ButtonGroup size="small" style={styles.buttonGroup}>
        <Button onClick={() => this.addToDate(-1, 'day')} style={styles.button}>
          <Icon>keyboard_arrow_left</Icon>
          Tag
        </Button>
        <Button onClick={() => this.addToDate(-1, 'week')} style={styles.button}>
          Woche
        </Button>
        <Button onClick={() => this.addToDate(-1, 'month')} style={styles.button}>
          Monat
        </Button>
      </ButtonGroup>
    );
  }

  renderNext() {
    return (
      <ButtonGroup size="small" style={styles.buttonGroup}>
        <Button onClick={() => this.addToDate(1, 'month')} style={styles.button}>
          Monat
        </Button>
        <Button onClick={() => this.addToDate(1, 'week')} style={styles.button}>
          Woche
        </Button>
        <Button onClick={() => this.addToDate(1, 'day')} style={styles.button}>
          Tag
          <Icon>keyboard_arrow_right</Icon>
        </Button>
      </ButtonGroup>
    );
  }

  render() {
    return (
      <div style={styles.container}>
        {this.renderPrevious()}
        {this.renderNext()}
      </div>
    );
  }
}

DateRangeStepper.propTypes = {
  startDate: momentPropTypes.momentObj,
  endDate: momentPropTypes.momentObj,
  onDatesChanged: PropTypes.func.isRequired,
};

DateRangeStepper.defaultProps = {
  startDate: null,
  endDate: null,
};

export default DateRangeStepper;
